import React, { useEffect, useRef, useState } from "react";
import { Chart as ChartJS, defaults } from "chart.js/auto";
import { Bar, Doughnut, Line, Chart } from "react-chartjs-2";
import { Button, Card, Col, Form, Row, Select } from "antd";
import { ConverData } from "helpers/dataToAntdSelect";
import { useDispatch } from "react-redux";
import { setAppLoading } from "app/slices/appSlice";
import { getDimensions, getMetrics } from "services/apiRequest";
import { forEach, isEqual } from "lodash";
import { formatNumber } from "helpers";

// import "./App.css";

defaults.maintainAspectRatio = false;
defaults.responsive = true;

defaults.plugins.title.display = true;
defaults.plugins.title.align = "start";
defaults.plugins.title.font.size = 20;
defaults.plugins.title.color = "black";

export default function BieuDo(props) {
    const [listGraphical, setListGraphical] = useState([]);
    const [defaultData, setDefaultData] = useState({ dimensions: [], metrics: [] });

    const { apiCallBack, metricId, dimensionId, dataFields, whereCondition, addGraphical } = props;

    const [fields, setFields] = useState(dataFields);

    const [form] = Form.useForm();

    useEffect(() => {
        if (!metricId || !dimensionId) {
            return;
        }

        const fetchData = async (dimensionId, metricId) => {
            try {
                // Chạy cả hai lời gọi bất đồng bộ song song
                const [dimensions, metrics] = await Promise.all([
                    getDimensions(dimensionId), // Lấy dimensions
                    getMetrics(metricId),       // Lấy metrics
                ]);

                // Gán kết quả vào đối tượng
                const obj = {
                    dimensions: dimensions?.data,
                    metrics: metrics?.data,
                };

                return obj;
            } catch (error) {
                console.error("Error fetching data:", error);
                throw error; // Bắn lỗi để xử lý nếu cần
            }
        };

        fetchData(metricId, dimensionId).then((data) => setDefaultData(data))
            .catch((error) => console.error("Failed to fetch data:", error));
        ;

    }, [metricId, dimensionId]);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!addGraphical) {
            return;
        }

        async function functionAddGraphical(params) {

            const { metric, dimension } = addGraphical;

            const length = listGraphical.length;
            form.setFieldValue(`metric-${length}`, +metric);
            form.setFieldValue(`dimension-${length}`, dimension != null ? +dimension : dimension);
            const graphical = await getNewGraphical(metric, dimension);
            if (!graphical?.data) {
                console.error("No data available");
                return;
            }

            const convertedGraphical = converGraphical(graphical.data);
            setListGraphical((prevList) => [...prevList, convertedGraphical]);
        }

        functionAddGraphical();

    }, [addGraphical]);

    useEffect(() => {
        if (!fields || !whereCondition) {
            return;
        }

        async function getDefaultGraphical() {

            dispatch(setAppLoading(true));

            // Tạo các promises từ dataFields
            const promises = fields.map((element, index) => {

                const metricIds = element.metricIds[0];
                const dimensionIds = element.dimensionIds[0];

                form.setFieldValue(`metric-${index}`, metricIds);
                form.setFieldValue(`dimension-${index}`, dimensionIds);

                const newWhereCondition = {
                    ...whereCondition,
                    metricIds: [metricIds],
                    dimensionIds: dimensionIds ? [dimensionIds] : []
                };
                return apiCallBack(newWhereCondition);
            });

            // Đợi tất cả promises hoàn thành
            const graphicals = await Promise.all(promises);

            // Chuyển đổi dữ liệu của phần tử đầu tiên

            setListGraphical(
                graphicals.map(element => converGraphical(element.data))
            );
            dispatch(setAppLoading(false));
        }

        getDefaultGraphical();

    }, [whereCondition]);


    async function getNewGraphical(metricIds, dimensionIds) {

        const newWhereCondition = {
            ...whereCondition,
            metricIds: [+metricIds],
            dimensionIds: dimensionIds ? [+dimensionIds] : []
        };

        return await apiCallBack(Object.assign({}, newWhereCondition ? newWhereCondition : {}));
    }

    const chartRefs = useRef([]);
    const [colors, setColors] = useState([
        '#0d6efd', '#6610f2', '#d63384', '#dc3545', '#fd7e14',
        '#ffc107', '#198754', '#20c997', '#0dcaf0', '#6f42c1',
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF"
    ]);

    function getRandomColor() {
        var letters = '0123456789abcdef';
        var color = '#';
        var colorss = [...colors];
        while (colorss.includes(color) || color == '#') {
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
        }
        colorss.push(color);
        setColors(colorss);
        return color;
    }

    function converGraphical(Unprocessed_Data) {
        if (Unprocessed_Data && Unprocessed_Data != undefined) {
            const _data = Unprocessed_Data;
            var data = { data: [], labels: [], total: [] };
            if (_data.data == undefined) {
                return;
            }

            for (let i = 0; i < _data.data.length; i++) {
                var dataPoints = [];
                var oldVal = -1;
                for (let j = 0; j < _data.data[i].data.length; j++) {
                    const value = _data.data[i].data[j];
                    const dateString = value.date;
                    const dateParts = dateString.split("/");
                    if (oldVal != dateParts[dateParts.length - 1]) {
                        oldVal = dateParts[dateParts.length - 1];
                    } else
                        dateParts.pop();
                    const date = dateParts.join("/");
                    if (i == 0) {
                        data.labels.push(date);
                    }
                    // const parts = dateString.split("/");
                    // const date = new Date(parts[2], parts[1] - 1, parts[0]);
                    dataPoints.push({ x: date, y: `${Number(value.value)}` });
                }
                data.data.push({
                    label: _data.data[i].name?.toString() ?? '',
                    backgroundColor: colors[i],
                    borderColor: i < colors.length ? colors[i] : getRandomColor(), data: dataPoints
                });
            }

            data.total = _data.total;

            return data;
        }
    };

    async function changeField(index) {
        try {
            dispatch(setAppLoading(true));

            const metric = form.getFieldValue(`metric-${index}`);
            const dimension = form.getFieldValue(`dimension-${index}`);

            let tmpFields = [...fields];

            tmpFields[index] = { metricIds: [metric], dimensionIds: [dimension] };

            setFields(tmpFields);

            let tmp = [...listGraphical];

            const graphical = await getNewGraphical(metric, dimension);

            tmp[index] = converGraphical(graphical?.data);

            setListGraphical(tmp);
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(setAppLoading(false));
        }
    }

    const renderGraphical = () =>
        listGraphical?.map((item, index) => {
            const span = listGraphical.length % 2 === 1 && index === listGraphical.length - 1 ? 24 : 12;

            return (
                <Col key={index} xs={24} md={24} lg={24} xl={span}>
                    <Card className="shadow-sm rounded-md mb-4 h-full">
                        <Form form={form}>
                            <div className="flex flex-wrap items-center gap-2">
                                <div className="flex items-center gap-2 min-w-[220px]">
                                    <div>Metrics</div>
                                    <Form.Item name={`metric-${index}`} style={{ margin: 0 }}>
                                        <Select
                                            style={{ width: "200px" }}
                                            onChange={() => changeField(index)}
                                            options={ConverData(defaultData.metrics || [])}
                                        />
                                    </Form.Item>
                                </div>

                                <div className="flex items-center gap-2 min-w-[220px]">
                                    <div>Dimension</div>
                                    <Form.Item name={`dimension-${index}`} style={{ margin: 0 }}>
                                        <Select
                                            style={{ width: "200px" }}
                                            className="w-full"
                                            onChange={() => changeField(index)}
                                            options={[
                                                { label: "Tất cả", value: null },
                                                ...ConverData(defaultData.dimensions.filter((d) => d.id != 1) || []),
                                            ]}
                                        />
                                    </Form.Item>
                                </div>

                                {index !== 0 && (
                                    <div className="min-w-[100px]">
                                        <Button
                                            danger
                                            onClick={() => {
                                                let tmp = [...listGraphical];
                                                tmp = tmp.filter((_, i) => i !== index);
                                                setListGraphical(tmp);
                                            }}
                                        >
                                            Xoá
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </Form>

                        <div className="w-full h-[30em]">
                            <Chart
                                ref={(el) => (chartRefs.current[index] = el)}
                                type="line"
                                data={{
                                    labels: item.labels,
                                    datasets: item.data,
                                }}
                                options={{
                                    elements: {
                                        line: {

                                        }
                                    },
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    aspectRatio: 2,
                                    stacked: true,
                                    plugins: {
                                        title: {
                                            display: true,
                                        },
                                        legend: {
                                            display: item.data.length > 20 ? false : true,
                                            position: "right",
                                            labels: {
                                                boxWidth: 10,
                                                boxHeight: 10,
                                                fontSize: 10,
                                                padding: 10,
                                            },
                                        },
                                        tooltip: {
                                            enabled: true,
                                            mode: "nearest",
                                            intersect: true,
                                        },
                                    },
                                    scales: {
                                        y: {
                                            beginAtZero: true,
                                        },
                                    },
                                }}
                            />
                        </div>
                        <div
                            className="row mx-n2 text-start mt-2 overflow-auto"
                            style={{ maxHeight: '20em' }}
                        >
                            {item &&
                                item.total &&
                                item.total.map((item1, index1) => {
                                    return (
                                        <span key={index1} className="col-12 col-sm-6 col-md-4 px-2">
                                            <span>
                                                {item1.name}: {`${formatNumber(item1?.value)} ${item?.unit ?? ""}`}
                                            </span>
                                        </span>
                                    );
                                })}
                        </div>
                    </Card>
                </Col >
            );
        });

    return (
        <div className="h-full w-full flex flex-col">
            <Row gutter={[16, 16]}>{renderGraphical()}</Row>
        </div>
    );
};
